/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overage`)
};

const es_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exceso`)
};

const de_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überschuss`)
};

const nl_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overmaat`)
};

const fr_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marge`)
};

const it_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Margine di sicurezza`)
};

const pt_br2_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excedente`)
};

const pt_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excedente`)
};

const ja_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーバーヘッジ`)
};

const zh_pcr_overage = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`损耗余量`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_overage = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_overage(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_overage", locale)
	if (locale === "en") return en_pcr_overage(inputs)
	if (locale === "es") return es_pcr_overage(inputs)
	if (locale === "de") return de_pcr_overage(inputs)
	if (locale === "nl") return nl_pcr_overage(inputs)
	if (locale === "fr") return fr_pcr_overage(inputs)
	if (locale === "it") return it_pcr_overage(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_overage(inputs)
	if (locale === "pt") return pt_pcr_overage(inputs)
	if (locale === "ja") return ja_pcr_overage(inputs)
	return zh_pcr_overage(inputs)
};